// extracted by mini-css-extract-plugin
export default {"container":"CustomCardContainer_container__Fl4xa"};